import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import { useEffect, useState } from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import iconDelete from "@iconify/icons-eva/person-delete-fill";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Stack, FormControlLabel, Radio, Switch, Button, TextField, RadioGroup, TableRow, TableBody, TableCell, Container, Typography, TableContainer } from "@mui/material";
// components
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import SearchNotFound from "src/components/SearchNotFound";

import axios from "axios";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import Confirm from "src/components/common/ConfirmDialog";
import PagePicker from "src/components/page-picker/PagePicker";
import Uploader from "src/components/uploader/Uploader";
import CellImage from "src/components/common/CellImage";
import { PAGE_TYPES } from "src/config/constants";

const TABLE_HEAD = [
  { id: "id", label: "ID", alignRight: false }, 
  { id: "name", label: "名称", alignRight: false }, 
  { id: "type", label: "页面类型", alignRight: false }, 
  { id: "createdAt", label: "添加时间", alignRight: false }, 
  { id: "updatedAt", label: "更新时间", alignRight: false }, 
  { id: "" }
];

const moreMenus = [
  { title: "编辑", icon: iconEdit2 },
  { title: "删除", icon: iconDelete },
];

export default function DiyList() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });

  const [action, setAction] = useState("");
  const [targetItem, setTargetItem] = useState({});
  const [form, setForm] = useState({
    name: "",
    icon: "",
    url: "",
    order: 0,
    isShow: 1,
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  function getItems() {
    axios
      .post("/diy/all", filter)
      .then((res) => {
        const { code, msg, data, count } = res.data;
        if (code === 1) {
          setItems(data);
          setTotal(count);
        } else {
          alert(msg);
        }
      })
      .catch((err) => {});
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      navigate(`/diy/edit/${row.id}`, { state: row });
    } else if (type === "删除") {
      handleDelBanner(row.id);
    }
  };

  function handleDelBanner(id) {
    Confirm({
      message: "删除不可恢复，确定删除吗?",
      onConfirm() {
        axios
          .post("/diy/del", { id })
          .then((res) => {
            const { code, msg, data } = res.data;
            if (code === 1) {
              setItems(items.filter((b) => b.id !== id));
            } else {
              alert(msg);
            }
          })
          .catch((err) => {
            console.log("删除装修页面失败: ", err);
          });
      },
    });
  }

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleAddItem() {
    setForm({
      name: "",
      icon: "",
      url: "",
      order: 0,
      isShow: 1,
    });
    setAction("add");
  }

  function handleDialogConfirm() {
    if (!form.icon) return alert("图片必须上传啊！！");

    const formData = { ...form };

    if (action === "edit") {
      formData.id = targetItem.id;
    }

    axios
      .post(action === "add" ? "/diy/add" : "/diy/edit", formData)
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          if (action === "add") {
            setItems([...items, data]);
          } else if (action === "edit") {
            const banner = items.find((b) => b.id === targetItem.id);
            Object.assign(banner, form);
            items.sort((c1, c2) => c2.order - c1.order);
            setItems([...items]);
          }

          setAction("");
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("添加或修改装修页面失败: ", err);
      });
  }

  // function handleSelectLink() {
  //   PagePicker({
  //     onSelect(link) {
  //       // console.log(link);
  //       handleIptChange("url", link);
  //     },
  //   });
  // }

  const isUserNotFound = items.length === 0;

  return (
    <Page title="装修页面列表">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            装修页面列表
          </Typography>

          <Button
            variant="contained"
            component={RouterLink}
            to="/diy/add"
            startIcon={<Icon icon={plusFill} />}
          >
            添加页面
          </Button>
        </Stack>

        <Card>
          <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {items.map((row) => {
                    const { id, name, icon, type, createdAt, updatedAt } = row;
                    const isItemSelected = selected.indexOf(icon) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={isItemSelected} aria-checked={isItemSelected}>
                        <TableCell align="left">{id}</TableCell>
                        <TableCell align="left">{name}</TableCell>
                        <TableCell align="left">{PAGE_TYPES[type]}</TableCell>

                        <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                        <TableCell align="left">{moment(updatedAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>

                        <TableCell align="right">
                          <MoreMenu spread menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>

    </Page>
  );
}
